import {PWMAT_RESOURCE} from './consts'

export const Tutorials = [
  {
    name:'Self-consistent calculation',
    url:PWMAT_RESOURCE+'tutorials-ppt/SCF.pptx',
    file_name:'SCF.pptx'
  },
  {
    name:'Band calculation',
    url:PWMAT_RESOURCE+'tutorials-ppt/BAND.pptx',
    file_name:'BAND.pptx'
  },
  {
    name:'Density of states calculation',
    url:PWMAT_RESOURCE+'tutorials-ppt/DOS.pptx',
    file_name:'DOS.pptx'
  },
  {
    name:'DFT+U calculation',
    url:PWMAT_RESOURCE+'tutorials-ppt/DFT+U.pptx',
    file_name:'DFT+U.pptx'
  },
  {
    name:'Spin Polarization Calculations',
    url:PWMAT_RESOURCE+'tutorials-ppt/SPIN.pptx',
    file_name:'SPIN.pptx'
  },
  {
    name:'Spin-orbit coupling & nonlinear magnetic moment',
    url:PWMAT_RESOURCE+'tutorials-ppt/SOC&NONCOLLINEAR.pptx',
    file_name:'SOC&NONCOLLINEAR.pptx'
  },
  {
    name:'Atomic position and lattice optimization calculation',
    url:PWMAT_RESOURCE+'tutorials-ppt/RELAX.pptx',
    file_name:'RELAX.pptx'
  },
  {
    name:'Molecular dynamics calculations',
    url:PWMAT_RESOURCE+'tutorials-ppt/MD.pptx',
    file_name:'MD.pptx'
  },
  {
    name:'Transition state calculations',
    url:PWMAT_RESOURCE+'tutorials-ppt/NEB.pptx',
    file_name:'NEB.pptx'
  },
  {
    name:'Time-dependent Density Functional Theory & Non-adiabatic Molecular Dynamics',
    url:PWMAT_RESOURCE+'tutorials-ppt/TDDFT&NAMD.pptx',
    file_name:'TDDFT&NAMD.pptx'
  },
  ]
